import { Accordion, Box, Container, rem, Stack, Text, Title } from '@mantine/core';

import { FAQ_ITEMS } from './faqItems';

export function FAQSection() {
  return (
    <Box py={rem(80)}>
      <Container size="md">
        <Stack align="center" gap="lg">
          <Stack align="center" gap="xs" ta="center">
            <Title order={1}>Frequently Asked Questions</Title>
            <Text size="sm" c="dimmed" maw={620}>
              Straight answers for people who keep their network deliberately - founders,
              consultants, and anyone who would rather nurture relationships than run growth-hacks.
            </Text>
          </Stack>

          <Accordion w="100%" variant="separated" radius="md">
            {FAQ_ITEMS.map((item) => (
              <Accordion.Item key={item.value} value={item.value}>
                <Accordion.Control>{item.question}</Accordion.Control>
                <Accordion.Panel>{item.answer}</Accordion.Panel>
              </Accordion.Item>
            ))}
          </Accordion>
        </Stack>
      </Container>
    </Box>
  );
}
